module.exports = __webpack_public_path__ + "assets/error-dark.145f4548.svg";